import React from "react";
import { Box } from "@chakra-ui/react";
import { useColorTheme } from "contexts/color-theme";
import { trackEvent } from "lib/analytics";
import { Link } from "ui/link";
import { ChevronRightIcon } from "ui/icons";
import { type SubNavItemProps } from "./data";

export function SubNavHeaderLink({ label, href }: SubNavItemProps) {
  const { theme, bgColor } = useColorTheme();

  const hoverBgColor =
    bgColor === "white" ? `brand.backgroundSecondary.light` : `brand.header.backgroundSecondary.${theme}`;

  const linkClicked = () => {
    trackEvent("Nav Item Clicked", {
      Label: label,
      Link: href,
    });
  };

  return (
    <Box
      as={Link}
      className="group"
      variant="unstyled"
      textStyle={{ base: "headline3", lg: "headline2", xl: "headline1" }}
      fontWeight={{ base: "semibold", lg: "bold", xl: "bold" }}
      href={href}
      borderRadius="base"
      bgColor="transparent"
      p="smaller"
      _hover={{
        bgColor: hoverBgColor,
        textDecoration: "none",
      }}
      onClick={linkClicked}
    >
      {label}
      <ChevronRightIcon
        boxSize="icon.lg"
        ml="tiny"
        transition="transform 0.15s ease-in-out"
        _groupHover={{ transform: "translateX(6px)" }}
      />
    </Box>
  );
}
